import Comparison from 'models/aiArtifacts/Comparison';
import AIJob, { AIJobOptions } from 'models/AIJob';
import Review, {
  BaseReviewData,
  BaseReviewDataOptions,
  getDefaults as getReviewDefaults,
  ReviewOptions,
  ReviewType,
} from 'models/Review';

type AuthorizationData = {
  authorizationNumber: string;
  approvedThroughDate: string;
  nextReviewDate: string;
  validThroughDate: string;
};
export interface AuthorizationOptions extends ReviewOptions {
  type: ReviewType.AUTHORIZATION;
  data: Partial<AuthorizationData & BaseReviewDataOptions>;
  typeDisplayName: string;
  previousAuthorizationReview?: Partial<AuthorizationOptions> | null;
  comparisonJobForCurrentSummary?: AIJobOptions | null;
}

export function getDefaults(): AuthorizationOptions {
  const defaults = getReviewDefaults();
  return {
    ...defaults,
    type: ReviewType.AUTHORIZATION,
    typeDisplayName: 'Authorization',
    previousAuthorizationReview: null,
    comparisonJobForCurrentSummary: null,
    data: {
      ...defaults.data,
      authorizationNumber: '',
      approvedThroughDate: '',
      nextReviewDate: '',
      validThroughDate: '',
    },
  };
}

export default class Authorization extends Review {
  declare type: ReviewType.AUTHORIZATION;
  declare data: AuthorizationData & BaseReviewData;
  typeDisplayName: string;
  previousAuthorizationReview: Authorization | null;
  comparisonJobForCurrentSummary: AIJob | null;

  constructor(options: Partial<AuthorizationOptions> = {}) {
    const opts = { ...getDefaults(), ...options };

    super(opts);
    this.typeDisplayName = opts.typeDisplayName;
    this.previousAuthorizationReview = opts.previousAuthorizationReview
      ? new Authorization(opts.previousAuthorizationReview)
      : null;
    this.comparisonJobForCurrentSummary = opts.comparisonJobForCurrentSummary
      ? new AIJob(opts.comparisonJobForCurrentSummary)
      : null;
  }

  static get type() {
    return ReviewType.AUTHORIZATION;
  }

  get comparisonJob(): AIJob {
    return this.comparisonJobForCurrentSummary as AIJob;
  }

  get comparison(): Comparison | undefined {
    return this.comparisonJobForCurrentSummary?.aiArtifact as Comparison | undefined;
  }

  get approvedThroughDate() {
    return this.data.approvedThroughDate;
  }
}
